/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de entradas.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
*      2       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Cabecero y totales compactos en dos filas
*      3       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Uso exclusivo del buscador de articulos portatil
* ---------------------------------------------------------------------------------------
*/

import FrmEntradasAlmacenesExhibidores from "../../inventarios/FrmEntradasAlmacenesExhibidores.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";
import ModalBuscarArticulosParaVentaPortatil from "../modales/ModalBuscarArticulosParaVentaPortatil.jsx";

export default function FrmEntradasAlmacenesExhibidoresPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmEntradasAlmacenesExhibidores">
      <FrmEntradasAlmacenesExhibidores
        ModalBuscarArticulosComponent={ModalBuscarArticulosParaVentaPortatil}
      />
    </SizeSoftXFrmPortatil>
  );
}
